export default "__VITE_ASSET__DhPeXPbj__"